<template>
  <div>
    <div class="contactContainer">
      <div class="contact">
        <div class="titleContainer">
          <div class="title">
            为提升客户服务质量，溢彩提供全年的客服在线服务
          </div>
          <span
            >如果您在订货中遇到任何问题，欢迎通过以下方式与我们取得联系。</span
          >
        </div>
        <div class="list">
          <ul>
            <li v-for="(item, index) in list" :key="index">
              <div class="headline" v-if="item.headline">
                {{ item.headline }}:
              </div>
              <div class="content" v-if="item.content">{{ item.content }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAboutus } from "@/api";
export default {
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async getAboutusList() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getAboutus({
        usercode,
        token,
      });
      this.list = JSON.parse(res);
    },
  },
  mounted() {
    this.getAboutusList();
  },
};
</script>
<style lang='less' scoped>
.contactContainer {
  .contact {
    width: 950px;
    margin: 0 auto;
    padding-top: 70px;
    font-size: 15px;
    color: #333333;
    .list {
      margin-top: 40px;
      ul li {
        height: 76px;
        line-height: 76px;
        display: flex;
        border-bottom: 1px solid #cccccc;
        .headline {
          width: 100px;
          margin-right: 150px;
          margin-left: 53px;
        }
        .content {
          white-space: pre;
        }
      }
    }
    .titleContainer {
      .title {
        margin-left: 53px;
        color: #e4040b;
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 5px;
      }
      span {
        margin-left: 53px;
        color: #333333;
        font-size: 15px;
      }
    }
  }
}
</style>